/* unplugin-vue-components disabled */import { render } from "./enrollment.vue?vue&type=template&id=69873257&scoped=true"
import script from "./enrollment.vue?vue&type=script&lang=js"
export * from "./enrollment.vue?vue&type=script&lang=js"

import "./enrollment.vue?vue&type=style&index=0&id=69873257&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69873257"]])

export default __exports__